module.exports = __webpack_public_path__ + "assets/img/net.1552ae9c.jpg";